import Axios from 'axios'
import moment from 'moment'
const p = (path = '') => `${window.$ApiHost}/users/${path ? path + '/' : path}`
const state = {
  params: {
    page: 1,
    limit: localStorage.getItem('usersPerPage') || 10,
    ordering: '',
  },
  total_pages: 0,
  total_objects: 0,
  items: [],
  itemsMore: [{ email: 'All', id: -1 }],
  hasItemsMore: true,
  isLoading: true,
  isLoadingMore: true,
}
const mutations = {
  // eslint-disable-next-line camelcase
  SET_LIST_USERS(state, { total_pages, total_objects, limit, page, results, ordering }) {
    // eslint-disable-next-line camelcase
    state.total_objects = total_objects
    // eslint-disable-next-line camelcase
    state.total_pages = total_pages
    state.items = results.map(e => ({
      ...e,
      date_joined: moment(e.date_joined).format('L'),
      last_login: moment(e.last_login).format('L'),
    }))
    state.params.limit = limit
    localStorage.setItem('usersPerPage', limit)
    state.params.page = page
    state.params.ordering = ordering
  },
  // eslint-disable-next-line camelcase
  SET_LIST_USERS_MORE(state, { results, total_objects }) {
    results.forEach(newElement => {
      const oldElementIndex = state.itemsMore.findIndex(oldElement => oldElement.id === newElement.id)
      if (oldElementIndex !== -1) {
        state.itemsMore[oldElementIndex] = newElement
      } else {
        state.itemsMore.push(newElement)
      }
    })
    // eslint-disable-next-line camelcase
    state.hasItemsMore = total_objects >= state.itemsMore.length
  },
  IS_LOADING_USERS(state, bool) {
    state.isLoading = bool
  },
  IS_LOADING_USERS_MORE(state, bool) {
    state.isLoading = bool
  },
}
const actions = {
  async getItems({ commit }, params = { ...state.params }) {
    commit('IS_LOADING_USERS', true)
    let response
    try {
      response = await Axios.get(p(), { params })
      commit('SET_LIST_USERS', { ...response.data, ...params })
    } catch (error) {
      response = error.response
    } finally {
      commit('IS_LOADING_USERS', false)
    }
    return response
  },
  async getItemsMore({ commit }, params) {
    commit('IS_LOADING_USERS_MORE', true)
    let response
    try {
      response = await Axios.get(p(), { params })
      commit('SET_LIST_USERS_MORE', { ...response.data, ...params })
    } catch (error) {
      response = error.response
    } finally {
      commit('IS_LOADING_USERS_MORE', false)
    }
    return response
  },
  async block({ dispatch }, { id, data = {} }) {
    let response
    try {
      response = await Axios.post(p(`${id}/blockeds`), data)
    } catch (e) {
      response = e.response
    } finally {

    }
    return response
  },
  async unBlock({ dispatch }, id) {
    let response
    try {
      response = await Axios.post(p(`${id}/unblockeds`))
    } catch (error) {
      response = error.response
    }
    return response
  },
  async sendNotification({ commit }, data) {
    let response
    try {
      response = await Axios.post(p('send/notifications'), data)
    } catch (error) {
      response = error.response
    }
    return response
  },
  async getUser({ commit }, id) {
    let response
    try {
      response = await Axios.get(p(id))
      const responsePublications = await Axios.get(p(`${id}/publications`))
      console.log(responsePublications)
      response.data.publications = responsePublications.data?.results
      commit('SET_LIST_USERS_MORE', { results: [response.data] })
    } catch (error) {
      response = error.response
    }
    return response
  },
  async getDeletedUsers({ commit }, params) {
    let response
    try {
      response = await Axios.get(p('deleting'), { params })
    } catch (error) {
      response = error.response
    } finally {
    }
    return response
  },
  async setFee({ commit }, body) {
    let res = null
    const { id } = body
    delete body.id
    try {
      res = await Axios.put(p(id), body)
    } catch ({ response }) { res = response } finally {}
    return res
  },
  async deleteUser({ commit }, playload) {
    let res = null
    try {
      res = await Axios.post(p('deleting'), playload)
    } catch ({ response }) { res = response } finally {}
    return res
  },
  // eslint-disable-next-line camelcase
  async getSvcUsers(_, { users_id = [] }) {
    let response
    try {
      response = await Axios.post(p('export'), { users_id })

      const blob = new Blob([response.data])
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `users-${new Date()}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    } catch (error) {
      response = error?.response
    }
    return response
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
